export const NEW_DYNAMIC_REPORT_ID = 'new-report';
